import(/* webpackMode: "eager" */ "/var/www/joy-awards-frontend-v3/public/assets/hero-hd.jpg");
;
import(/* webpackMode: "eager" */ "/var/www/joy-awards-frontend-v3/public/assets/trophy_2026.png");
;
import(/* webpackMode: "eager", webpackExports: ["Ceremony"] */ "/var/www/joy-awards-frontend-v3/src/app/[lang]/about/components/ceremony.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/joy-awards-frontend-v3/src/app/[lang]/about/components/html-content-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/joy-awards-frontend-v3/src/app/[lang]/about/components/video.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/joy-awards-frontend-v3/src/components/shared/image/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/joy-awards-frontend-v3/src/components/ui/animations/fade.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/joy-awards-frontend-v3/src/components/ui/animations/reveal.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/joy-awards-frontend-v3/src/components/ui/animations/zoom.tsx");
